import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {PromotedSponsorshipModuleConfig} from "./promoted-sponsorship-module.config";
import {PromotedSponsorshipModuleState} from "./models/promoted-sponsorship-module.state";

export class PromotedSponsorshipModuleStore extends BaseMobxStore {
  static injectables = [PromotedSponsorshipModuleConfig, PromotedSponsorshipModuleState];
}

